<template>
  <el-dialog title="Agendar Vistoria" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" :modal-append-to-body="false" width="40%">
    <el-form :model="vistoria" size="small" label-position="top">
      <el-row :gutter="20">
        <el-col :md="6" :lg="7">
          <el-form-item label="Tipo">
            <el-select v-model="vistoria.tipo">
              <el-option :key="1" label="Entrada" value="ENTRADA"/>
              <el-option :key="2" label="Entrada - Complemento" value="ENTRADA_COMPLEMENTO"/>
              <el-option :key="3" label="Saída" value="SAIDA"/>
              <el-option :key="4" label="Saída - Complemento" value="SAIDA_COMPLEMENTO"/>
            </el-select>
          </el-form-item>
        </el-col>
        
        <el-col :md="6" :lg="7">
          <el-form-item label="Data">
            <el-date-picker
              v-model="vistoria.dataAgendamento"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
            />
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-form-item label="Vistoriador" style="width: 100%">
        <el-select v-model="vistoria.usuario"
          :remote-method="recuperarAtendentesSelect"
          :loading="loading.usuarios"
          value-key="id"
          loading-text="Carregando usuários"
          no-data-text="Nenhum usuário encontrado"
          filterable remote reserve-keyword placeholder
          style="width: 100%">
          <el-option v-for="item in dataSelect.usuarios" :key="item.id" :label="item.nome" :value="item"/>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="agendarVistoriaHandler()" size="small" round class="btn-box-shadow">Confirmar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Util from "../../../util/funcoes.js";

export default {
  
  props: {
    visibility: Boolean
  },
  data() {
    return {
      loading: { usuarios: false },

      dataSelect: { usuarios: [] },

      vistoria: {
        tipo: '',
        usuario: { id: 0, nome: "" },
        dataAgendamento: Util.agora()
      }
    };
  },
  computed: {
    ...mapState("alugueisContratosStore", {
      aluguel(state) { return state.aluguelSelecionado; },
    })
  },
  methods: {
    ...mapActions(["showLoading", "hideLoading"]),
    ...mapActions("usuariosStore", ["listarUsuarios"]),
    ...mapActions("alugueisContratosStore", ["agendarVistoria"]),
    
    recuperarAtendentesSelect(queryString) {
      let payload = { nome: queryString };

      this.loading.usuarios = true;
      this.listarUsuarios(payload)
      .then((resultado) => {
        this.loading.usuarios = false;
        if(resultado.status == "SUCESSO") {
          this.dataSelect.usuarios = resultado.lista;
        }
      }).catch(() => {
        this.loading.usuarios = false;
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },
    agendarVistoriaHandler() {
      this.vistoria.aluguel = {
        id: this.aluguel.id
      };
      this.vistoria.imovel = {
        id: this.aluguel.imovel.id
      }
      
      this.showLoading();
      this.agendarVistoria(this.vistoria).then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.fechar();
            break;
          default:
            this.$message.error(resultado.mensagem);
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível comunicar-se com o servidor");
      });
    },
    fechar() {
      this.dataSelect = { usuarios: [] };

      this.vistoria = {
        tipo: '',
        usuario: { id: 0, nome: "" },
        dataAgendamento: Util.agora()
      }

      this.$emit("close");
    }
  }
};
</script>

